export default __webpack_public_path__ + "static/commercial-bf4c95ea4aac6eaf53dc8381b7060381.jpeg";